import { render } from "./Oxygen.vue?vue&type=template&id=35049ae8"
import script from "./Oxygen.vue?vue&type=script&lang=ts"
export * from "./Oxygen.vue?vue&type=script&lang=ts"
script.render = render

export default script